import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import CourseDetails from "./components/CourseDetails";
import FooterSection from "./components/FooterSection/FooterSection";
import { HeroSection } from "./components/HeroSection";
import ListSection from "./components/ListSection";
import { Navbar } from "./components/Navbar/Navbar";
import ContactSection from "./components/ContactSection";
import AboutSection from "./components/AboutSection";
import TermsSection from "./components/TermsSection";
import NotFound from "./components/404Section";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Navbar />
        <Switch>
          <Route path="/courses/course" component={CourseDetails} />
          <Route path="/courses" component={ListSection} />

          <Route path="/terms" component={TermsSection} />
          <Route path="/about" component={AboutSection} />
          <Route path="/contact" component={ContactSection} />
          <Route exact path="/" component={HeroSection} />
          <Route component={NotFound} />
        </Switch>
        <FooterSection />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
